export const formatCardNumber = (cardNumber: string): string => {
  const cleanedNumber = cardNumber.replace(/\D/g, 'X') // Remove non-digit characters
  return cleanedNumber.replace(/(.{4})/g, '$1 ').trim() // Add space every 4 digits
}
